import { render } from "./WorldPlayTerms.vue?vue&type=template&id=2e044c7a"
import script from "./WorldPlayTerms.vue?vue&type=script&lang=js"
export * from "./WorldPlayTerms.vue?vue&type=script&lang=js"

import "./WorldPlayTerms.vue?vue&type=style&index=0&id=2e044c7a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__